module.exports = __webpack_public_path__ + "f8d1c306b5ca62339039f2f8c68741ae.svg";